import utils = egr.wcf.utils;

/**
 * Retuns the content of the given url as ArrayBuffer.
 */
export function getContent(url: string): Promise<ArrayBuffer> {
    return utils.async.ajax('GET', url, null, {
        responseType: 'arraybuffer'
    });
}

/**
 * This function can be used to load or download content via an hidden iframe.
 */
export function loadHiddenFrame(url: string, removeAfter: number = 0): () => void {
    const iframe: HTMLIFrameElement = document.createElement('iframe') as HTMLIFrameElement;
    iframe.frameBorder = '0px';
    iframe.width = '0px';
    iframe.height = '0px';
    iframe.src = url;

    document.body.appendChild(iframe);

    let timeout: number | undefined;
    const removeFunc: () => void = () => {
        // Needed if the returned callback is used
        // to remove the frame from the DOM
        if (timeout !== undefined) {
            clearTimeout(timeout);
        }

        document.body.removeChild(iframe);

    };

    if (removeAfter > 0) {
        timeout = window.setTimeout(removeFunc, removeAfter);
    }

    return removeFunc;
}

export function downloadUrl(link: string, filename: string): void {
    if (utils.string.isNullOrEmpty(link)) {
        return;
    }
    const anchor: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.href = link;
    anchor.target = '_blank';
    anchor.download = filename;
    anchor.click();
    document.body.removeChild(anchor);
}

export function downloadBlob(blob: Blob, filename: string): void {
    if (navigator.msSaveBlob != null) {
        // IE
        navigator.msSaveBlob(blob, filename);
    } else if (navigator.msSaveOrOpenBlob != null) {
        // IE
        navigator.msSaveOrOpenBlob(blob, filename);
    } else {
        const url: string = URL.createObjectURL(blob);
        downloadUrl(url, filename);
        URL.revokeObjectURL(url);
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/utils/Download.ts